<template>
  <div class="modal_wrapper">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <img :src="caution" height="25px" />
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">{{ message }}</div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="okButton"
              class="finish_button"
              @click="$emit('close')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {
      caution: require('../../img/caution.png'),
      okButton: 'OK',
      title: 'メンテナンス中'
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.modal_container {
  width: 435px;
  height: 375px;
}
.container {
  display: table-cell;
  vertical-align: middle;
}

.modal_body {
  width: 100%;
  height: 250px;
  margin: 0 auto;
  color: #000;
  overflow-y: scroll;
}

.body {
  width: 100%;
  height: 100%;
  padding: 30px 30px 0 30px;
  box-sizing: border-box;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/maintenanceModalWindow.vue